import {TextInput} from 'react-native';
import {RFValue} from 'react-native-responsive-fontsize';
import Feather from 'react-native-vector-icons/Feather';
import styled from 'styled-components/native';

export const Container = styled.View`
  height: ${RFValue(35)}px;
  padding: 0 ${RFValue(14)}px;
  border-radius: ${RFValue(35)}px;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  background: ${({theme}) => theme.colors.input_search};
`;

export const ContainerButton = styled.TouchableOpacity`
  height: ${RFValue(35)}px;
  padding: 0 ${RFValue(1)}px 0 ${RFValue(12)}px;
  border-radius: ${RFValue(35)}px;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  background: ${({theme}) => theme.colors.input_search};
`;

export const Input = styled(TextInput)`
  height: ${RFValue(35)}px;
  border-radius: ${RFValue(35)}px;
  margin-right: ${RFValue(12)}px;
  font-family: ${({theme}) => theme.fonts.regular};
  color: ${({theme}) => theme.colors.text_dark};
  font-size: ${RFValue(12)}px;
  flex: 1;
`;

export const InputButton = styled.View`
  height: ${RFValue(35)}px;
  flex: 1;
  flex-direction: row;
  align-items: center;
`;

export const InputText = styled.Text`
  font-family: ${({theme}) => theme.fonts.regular};
  color: ${({theme}) => theme.colors.text};
  font-size: ${RFValue(10)}px;
  flex: 1;
`;

export const SearchIcon = styled(Feather)`
  font-size: ${RFValue(14)}px;
  background: ${({theme}) => theme.colors.input_search};
  z-index: 2;
`;
